import APIClient from './index';
import _ from 'lodash';

export const getFeatured = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Featured/`)
      .then(response => resolve(response.data))
      .catch(err => reject(false));
  });
};

export const updateFeaturedItem = (featured, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/Featured/${featured.id}`, data)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};

export const getShopExamples = params => {
  return new Promise((resolve, reject) => {
    APIClient.get('Featured/shop_examples')
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};

export const getShopFeatures = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/ShopFeatures${_.size(params) ? `?${new URLSearchParams(params).toString()}` : ''}`)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};

export const addShopFeature = feature => {
  return new Promise((resolve, reject) => {
    APIClient.post('ShopFeatures', feature)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};

export const updateShopFeature = (feature, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`ShopFeatures/${feature.id}`, updates)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};

export const deleteShopFeature = feature => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`ShopFeatures/${feature.id}`)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};
